/**
 * 各种画echarts图表的方法都封装在这里
 */

import echarts from 'echarts'
const install = function(Vue) {
  Object.defineProperties(Vue.prototype, {
    $chart1: {
      get() {
        return {
          clearLine: function(id) {
            this.chart = echarts.init(document.getElementById(id))
            this.chart.clear()
          },
          line1: function(id, linesParams) {
            this.chart = echarts.init(document.getElementById(id))
            this.chart.clear()

            const optionData = {
              title: {
                text: linesParams.titleText,
                x: 'center',
                y: 'top',
                textAlign: 'left'
              },
              tooltip: {
                trigger: 'axis'
              },
              legend: {
                data: linesParams.legendData,
                // icon: 'circle',
                bottom: '0',
                // textStyle: {
                //   padding: [0, 0, 0, 0]
                // },
                orient: 'horizontal'
              },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '15%',
                containLabel: true
              },
              toolbox: {
                emphasis: {
                  iconStyle: {
                    textPosition: 'left'
                  }
                },
                feature: {
                  saveAsImage: { show: true, title: '保存图片            ' }
                }
              },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: linesParams.xAxisData
              },
              yAxis: {
                type: 'value'
              },
              series: linesParams.series
            }

            this.chart.setOption(optionData)
          }
        }
      }
    }
  })
}

export default {
  install
}
